export default {
  // Pixels Management
  "pixelsManagement.add": "Add",
  "pixelsManagement.details": "Details",
  "pixelsManagement.edit": "Edit",
  "pixelsManagement.delete": "Delete",
  "pixelsManagement.delete.confirm.title": "Delete Configuration",
  "pixelsManagement.delete.confirm.content": "Are you sure you want to delete this configuration?",
  "pixelsManagement.delete.confirm.okText": "Confirm",
  "pixelsManagement.delete.confirm.cancelText": "Cancel",
  "pixelsManagement.modal.title": "Pixels Management Configuration",
  "pixelsManagement.thead.createdAt": "Created At",
  "pixelsManagement.thead.updatedAt": "Updated At",
  "pixelsManagement.thead.action": "Action",

  // Pixel fields
  "pixelsManagement.thead.id": "ID",
  "pixelsManagement.thead.documentId": "Document ID",
  "pixelsManagement.thead.pixelId": "Pixel ID",
  "pixelsManagement.thead.providerType": "Provider Type",
  "pixelsManagement.thead.initInChannel": "Init In Channel",
  "pixelsManagement.thead.initToApp": "Init To App",
  "pixelsManagement.thead.pwaStartUrl": "PWA Start URL",
  "pixelsManagement.thead.testEventCode": "Test Event Code",
  "pixelsManagement.thead.accessToken": "Access Token",
  "pixelsManagement.thead.remark": "Remark",
  "pixelsManagement.thead.bindSite": "Bind Site",
  "pixelsManagement.thead.title": "Title",
  "pixelsManagement.thead.key": "Key",
  "pixelsManagement.thead.groupKey": "Group Key",
  "pixelsManagement.thead.sort": "Sort",
  "pixelsManagement.thead.other": "Other",
  "pixelsManagement.thead.createdBy": "Created By",
  "pixelsManagement.thead.updatedBy": "Updated By",
};

